export enum LoadingState {
    LOADING,
    COMPLETE,
    FAILED,
}
